export { default } from './DividerBlock';
export * from './DividerBlock';
